/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AddonsIdGet200Response model module.
 * @module model/AddonsIdGet200Response
 * @version 1.0.0
 */
class AddonsIdGet200Response {
    /**
     * Constructs a new <code>AddonsIdGet200Response</code>.
     * @alias module:model/AddonsIdGet200Response
     */
    constructor() { 
        
        AddonsIdGet200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AddonsIdGet200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AddonsIdGet200Response} obj Optional instance to populate.
     * @return {module:model/AddonsIdGet200Response} The populated <code>AddonsIdGet200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AddonsIdGet200Response();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('legacyId')) {
                obj['legacyId'] = ApiClient.convertToType(data['legacyId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AddonsIdGet200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AddonsIdGet200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['legacyId'] && !(typeof data['legacyId'] === 'string' || data['legacyId'] instanceof String)) {
            throw new Error("Expected the field `legacyId` to be a primitive type in the JSON string but got " + data['legacyId']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * The internal product ID
 * @member {String} id
 */
AddonsIdGet200Response.prototype['id'] = undefined;

/**
 * The legacy product ID
 * @member {String} legacyId
 */
AddonsIdGet200Response.prototype['legacyId'] = undefined;

/**
 * Name of the addon
 * @member {String} name
 */
AddonsIdGet200Response.prototype['name'] = undefined;






export default AddonsIdGet200Response;

